import React from 'react';
import RowWrapper from './RowWrapper';

export interface Props {
  rowIdx: number;
  width: number;
  height: number;
  scrollOptims?: boolean;
  children: React.ReactNode;
  rowAlign?: 'left' | 'center' | 'right';
}

const ItemRow: React.FC<Props> = ({
  rowIdx,
  width,
  height,
  scrollOptims,
  children,
  rowAlign,
}) => {
  let rowStyle: React.CSSProperties = {};
  if (rowAlign) {
    const settingToCss = {
      left: 'flex-start',
      right: 'flex-end',
      center: 'center',
    };
    rowStyle = { display: 'flex', justifyContent: settingToCss[rowAlign] };
  }
  return (
    <RowWrapper
      style={
        {
          width: width,
          containIntrinsicSize: `${width}px ${height}px`,
          contentVisibility: scrollOptims ? 'auto' : 'visible',
          ...rowStyle,
        } as React.CSSProperties
      }
    >
      {children}
    </RowWrapper>
  );
};
ItemRow.displayName = 'ItemRow';

export default ItemRow;
